export default {
  "content": "<g clip-path=\"url(#icon_arrow_down_right_outlined_svg__a)\"><path fill-rule=\"evenodd\" d=\"M15.679 8.745l-2.06 1.91-1.78 1.72h-.01s-.01.01-.01.02c-.1.07-.2.11-.32.11s-.26-.05-.36-.16c-.19-.2-.18-.52.03-.7l1.78-1.72s.01 0 .02-.02l1.49-1.4H.499c-.28 0-.5-.22-.5-.5v-3.43c0-.28.22-.5.5-.5s.5.22.5.5v2.93h13.47l-3.32-3.15a.484.484 0 01-.03-.7.5.5 0 01.37-.16c.12 0 .22.04.32.11l3.87 3.67c.43.39.43 1.07 0 1.47z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_arrow_down_right_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};